// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-text-block__container {
  display: flex;
  background-color: var(--white-color);
}
.background-text-block__container .title2-text {
  color: var(--web-primary-color);
}

.background-text {
  text-transform: uppercase;
  font-weight: 900;
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
  color: #E5E4E2;
}

.background-text-block__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  z-index: 1;
}

@media only screen and (min-device-width: 320px) {
  .background-text {
    top: 8px;
    left: 5%;
    font-size: 80px;
    letter-spacing: 4px;
  }
  .background-text-block__content {
    gap: 17px;
    margin-top: -40px;
    margin-left: 5%;
    margin-right: 0;
    padding-bottom: 45px;
    width: 86%;
  }
}
@media only screen and (min-device-width: 768px) {
  .background-text {
    top: 28px;
    left: 8.9%;
    font-size: 100px;
    letter-spacing: 5px;
  }
  .background-text-block__content {
    gap: 16px;
    margin-top: -30px;
    margin-left: calc(8.9% + 51px);
    margin-right: 0;
    padding-bottom: 90px;
    width: 74.4%;
  }
}
@media only screen and (min-device-width: 992px) {
  .second-block__container {
    min-width: 992px;
  }
  .background-text {
    top: 52px;
    left: 8.1%;
    font-size: 160px;
    letter-spacing: 8px;
  }
  .background-text-block__content {
    gap: 32px;
    margin-top: -30px;
    margin-left: calc(8.1% + 106px);
    margin-right: 0;
    padding-bottom: 90px;
    width: 67.5%;
  }
}
@media only screen and (min-device-width: 1366px) {
  .background-text {
    top: 76px;
    left: 15.6%;
    font-size: 200px;
    letter-spacing: 10px;
  }
  .background-text-block__content {
    gap: 32px;
    margin-top: -35px;
    margin-left: calc(15.6% + 124px);
    margin-right: 0;
    padding-bottom: 137px;
    width: 58.9%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BackgroundTextBlock/backgroundtextBlock.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;AACF;AACE;EACE,+BAAA;AACJ;;AAGA;EACE,yBAAA;EACA,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EAEA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AADF;;AAIA;EACE;IACE,QAAA;IACA,QAAA;IACA,eAAA;IACA,mBAAA;EADF;EAGA;IACE,SAAA;IACA,iBAAA;IACA,eAAA;IACA,eAAA;IACA,oBAAA;IACA,UAAA;EADF;AACF;AAIA;EACE;IACE,SAAA;IACA,UAAA;IACA,gBAAA;IACA,mBAAA;EAFF;EAIA;IACE,SAAA;IACA,iBAAA;IACA,8BAAA;IACA,eAAA;IACA,oBAAA;IACA,YAAA;EAFF;AACF;AAMA;EACE;IACE,gBAAA;EAJF;EAMA;IACE,SAAA;IACA,UAAA;IACA,gBAAA;IACA,mBAAA;EAJF;EAMA;IACE,SAAA;IACA,iBAAA;IACA,+BAAA;IACA,eAAA;IACA,oBAAA;IACA,YAAA;EAJF;AACF;AAQA;EACE;IACE,SAAA;IACA,WAAA;IACA,gBAAA;IACA,oBAAA;EANF;EAQA;IACE,SAAA;IACA,iBAAA;IACA,gCAAA;IACA,eAAA;IACA,qBAAA;IACA,YAAA;EANF;AACF","sourcesContent":[".background-text-block__container {\n  display: flex;\n  background-color: var(--white-color);\n\n  .title2-text {\n    color: var(--web-primary-color);\n  }\n}\n\n.background-text {\n  text-transform: uppercase;\n  font-weight: 900;\n  width: fit-content;\n  position: relative;\n  //opacity: 0.08;\n  color: #E5E4E2;\n}\n\n.background-text-block__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n  z-index: 1;\n}\n\n@media only screen and (min-device-width: 320px) {\n  .background-text {\n    top: 8px;\n    left: 5%;\n    font-size: 80px;\n    letter-spacing: 4px;\n  }\n  .background-text-block__content {\n    gap: 17px;\n    margin-top: -40px;\n    margin-left: 5%;\n    margin-right: 0;\n    padding-bottom: 45px;\n    width: 86%;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .background-text {\n    top: 28px;\n    left: 8.9%;\n    font-size: 100px;\n    letter-spacing: 5px;\n  }\n  .background-text-block__content {\n    gap: 16px;\n    margin-top: -30px;\n    margin-left: calc(8.9% + 51px);\n    margin-right: 0;\n    padding-bottom: 90px;\n    width: 74.4%;\n  }\n\n}\n\n@media only screen and (min-device-width: 992px) {\n  .second-block__container {\n    min-width: 992px;\n  }\n  .background-text {\n    top: 52px;\n    left: 8.1%;\n    font-size: 160px;\n    letter-spacing: 8px;\n  }\n  .background-text-block__content {\n    gap: 32px;\n    margin-top: -30px;\n    margin-left: calc(8.1% + 106px);\n    margin-right: 0;\n    padding-bottom: 90px;\n    width: 67.5%;\n  }\n\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .background-text {\n    top: calc(48px + 28px);\n    left: 15.6%;\n    font-size: 200px;\n    letter-spacing: 10px;\n  }\n  .background-text-block__content {\n    gap: 32px;\n    margin-top: -35px;\n    margin-left: calc(15.6% + 124px);\n    margin-right: 0;\n    padding-bottom: 137px;\n    width: 58.9%;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
